(function(){
	'use strict';

	angular
	.module('app.blog')
	.controller('InicialBlogController', InicialBlogController)

	function InicialBlogController(API, blogFactory) {
		let vm = this;

		vm.$onInit = () => {
			getFromAPI();
		}
		
		function getFromAPI() {
			API.get(`post`).then(result => {
				vm.posts = result.data;
			});
			API.get('projeto/destaques').then(result => {
				vm.solucoes = result.data;
			});
		}
	}

})();
